import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { callApi, formatDate, formatMoney, getInlineLoader } from "../Helpers";
import { STR__NORMAL_SMS, STR_BUY_NOW, STR_DAYS, STR_FROM, STR_MY_SUBSCRIPTION, STR_PRICE, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SELECT, STR_SUBSCRIPTION_AMOUNT, STR_SUBSCRIPTION_HAS_EXPIRED, STR_SUBSCRIPTION_TYPE, STR_TO, STR_WHATSAPP_MESSAGE } from "../Strings";
import { MdWarning } from "react-icons/md";
import { IoWarningOutline } from "react-icons/io5";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [subscriptionAmount, setSubscriptionAmount] = useState(0);
	const [subscriptionPrice, setSubscriptionPrice] = useState(0);
	const [subscriptionType, setSubscriptionType] = useState('normalSms');


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
			appContext.getSystemParams(),
		])
		setReady(true);
	}
	


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		let _totalPrice = 0;
		let _unitPrice = 0;

		if(subscriptionType === 'normalSms') {
			_unitPrice = appContext.systemParams.normalSmsPrice;
		} else if(subscriptionType === 'whatsApp') {
			_unitPrice = appContext.systemParams.whatsAppPrice;
		}

		if(!isNaN(subscriptionAmount)) {
			_totalPrice = Number(subscriptionAmount) * Number(_unitPrice);
		}

		setSubscriptionPrice(_totalPrice);
	}, [ subscriptionAmount, subscriptionType ])

	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<h6
								style={{
									fontSize: "28px",
								}}
								className="font-light mb-4 mt-4"
							>
								{STR_MY_SUBSCRIPTION[appContext.language]}
							</h6>
						</div>

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<div className="row">
										<div className="col-md-6 mt-2 mb-2">

											<h6
												style={{
													fontSize: "32px"
												}}
												className="font-bold"
											>
												{formatMoney(appContext.currentUserData.normalSmsBalance)}
												<span
													className="font-semi-bold text-muted d-block"
													style={{
														fontSize: "12px"
													}}
												>
													SMS Balance
												</span>
											</h6>

										</div>

										<div className="col-md-6 mt-2 mb-2">

											<h6
												style={{
													fontSize: "32px"
												}}
												className="font-bold"
											>
												{formatMoney(appContext.currentUserData.whatsAppBalance)}
												<span
													className="font-semi-bold text-muted d-block"
													style={{
														fontSize: "12px"
													}}
												>
													WhatsApp Balance
												</span>
											</h6>
											
										</div>

										<div className="col-md-12">
											<button
												className="btn btn-block btn-rounded btn-padded bg-secondary mt-4 mb-4"
												onClick={() => {
													appContext.navTo({
														item: 'bottom-view',
														subItem: 'buy-subscription-package',
													})
												}}
											>
												{STR_BUY_NOW[appContext.language]}
											</button>
										</div>

									</div>
								</div>
							</div>
						</div>

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}